import { AttachmentPreviewHeader } from '@components/icons/AttachmentPreviewHeader'
import { Modal } from '@components/Modal'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Document, Page, pdfjs } from 'react-pdf'

import TrashIcon from '@/assets/icons/trash.svg'
import { Attachment } from '@/contexts/consultation'

try {
  pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()
} catch (e) {
  // This is needed for tests
  console.warn(e)
}

type AttachmentPreviewProps = {
  attachment: Attachment
  onClose: () => void
  onRemove: () => void
}

export const AttachmentPreview = ({ attachment, onClose, onRemove }: AttachmentPreviewProps) => {
  const { t } = useTranslation()
  const [numPages, setNumPages] = useState<number | null>(null)

  return (
    <Modal
      header={{
        icon: <AttachmentPreviewHeader customClassName="text-primary" />,
        title: t('attachmentPreview.title')
      }}
      onClose={onClose}
      dataTestId="attachment-preview"
      fullScreen
    >
      <div className="flex flex-col items-center gap-4 rounded-sm bg-white p-3 shadow-sm">
        {attachment.file.type === 'application/pdf' ? (
          <Document
            className="replay-block"
            file={attachment.file}
            onLoadSuccess={({ numPages }) => {
              setNumPages(numPages)
            }}
          >
            {Array.from(new Array(numPages), (_, index) => (
              <Page
                key={`page_${index + 1}`}
                className="border-gray-text/25 mt-1 border"
                pageNumber={index + 1}
                width={window.innerWidth - 100}
                renderAnnotationLayer={false}
                renderTextLayer={false}
              />
            ))}
          </Document>
        ) : (
          <img src={attachment.preview as string} className="replay-block w-full" />
        )}

        <button className="flex items-center gap-2 py-2" onClick={onRemove} data-testid="remove-attachment-button">
          <img src={TrashIcon} className="h-4 w-4" />
          <p className="text-sm font-bold uppercase">{t('button.remove')}</p>
        </button>
      </div>
    </Modal>
  )
}
